.spinner {
  display: inline-flex;
  flex: none;
  inline-size: var(--icon-sm);
  block-size: var(--icon-sm);
  color: currentcolor;
}

.spinner[data-size="md"] {
  inline-size: var(--icon-md);
  block-size: var(--icon-md);
}

.spinner[data-size="lg"] {
  inline-size: var(--icon-lg);
  block-size: var(--icon-lg);
}

.svg {
  inline-size: 100%;
  block-size: 100%;
  fill: none;
  stroke: currentcolor;
  stroke-width: 2.5;
  stroke-linecap: round;
  animation: spin var(--duration-spinner) linear infinite;
}

.track {
  opacity: 0.25;
}

.label {
  position: absolute;
  inline-size: 1px;
  block-size: 1px;
  overflow: hidden;
  clip-path: inset(50%);
  white-space: nowrap;
}

@keyframes spin {
  to {
    transform: rotate(360deg);
  }
}
